import { render, staticRenderFns } from "./ChatHeader.vue?vue&type=template&id=62a8a342&scoped=true"
import script from "./ChatHeader.vue?vue&type=script&lang=js"
export * from "./ChatHeader.vue?vue&type=script&lang=js"
import style0 from "./ChatHeader.vue?vue&type=style&index=0&id=62a8a342&prod&scoped=true&lang=css"
import style1 from "./ChatHeader.vue?vue&type=style&index=1&id=62a8a342&prod&lang=css"
import style2 from "./ChatHeader.vue?vue&type=style&index=2&id=62a8a342&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a8a342",
  null
  
)

export default component.exports